import React, { useEffect } from 'react';
import { XIcon } from './Icons';
import { motion, AnimatePresence } from 'framer-motion';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export const PolicyModal: React.FC<PolicyModalProps> = ({
  isOpen,
  onClose,
  title,
  content
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-241">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 z-50 backdrop-blur-sm" data-id="element-242" />
          <motion.div initial={{
        opacity: 0,
        y: '100%',
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: '100%',
        scale: 0.9
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed inset-x-4 bottom-4 top-20 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-2xl md:h-[80vh] bg-white rounded-2xl shadow-2xl z-50 flex flex-col overflow-hidden" data-id="element-243">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-244">
              <h2 className="text-2xl font-bold text-forest" data-id="element-245">{title}</h2>
              <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-500 hover:text-charcoal" data-id="element-246">
                <XIcon className="w-6 h-6" data-id="element-247" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1 text-gray-600 space-y-4" data-id="element-248">
              {content}
            </div>
            <div className="p-6 border-t border-gray-100 bg-gray-50" data-id="element-249">
              <button onClick={onClose} className="w-full md:w-auto px-6 py-3 bg-forest text-white font-semibold rounded-lg hover:bg-forest/90 transition-colors" data-id="element-250">
                Close
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
};